import React from "react";
import { ISAD_CONFIG } from "../../models/isad";
import { RECENT_RECLASSIFICATIONS, RECENT_ANOMALIES } from "../../mock/summary.mock";

function relativeTime(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const h = Math.floor(diff / 3600000);
  const d = Math.floor(h / 24);
  if (d > 0) return `${d}d ago`;
  if (h > 0) return `${h}h ago`;
  const m = Math.floor(diff / 60000);
  return m > 0 ? `${m}m ago` : "just now";
}

function IsadBadge({ level }) {
  return (
    <span
      className="rounded px-1 py-0.5 text-xs font-bold text-white"
      style={{ backgroundColor: ISAD_CONFIG[level]?.color }}
    >
      {level}
    </span>
  );
}

export default function RecentChanges({ onItemClick }) {
  return (
    <div className="space-y-3">
      <div>
        <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
          Reclassifications
        </p>
        <ul className="space-y-1">
          {RECENT_RECLASSIFICATIONS.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => onItemClick(item.segmentId)}
                className="flex w-full items-center justify-between rounded px-1 py-1 text-left text-xs hover:bg-gray-50 dark:hover:bg-white/5"
              >
                <span className="flex items-center gap-1.5">
                  <span className="text-navy-700 dark:text-white">
                    {item.kmRange}
                  </span>
                  <IsadBadge level={item.from} />
                  <span className="text-gray-400">→</span>
                  <IsadBadge level={item.to} />
                </span>
                <span className="text-gray-400">{relativeTime(item.timestamp)}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
          Anomalies
        </p>
        <ul className="space-y-1">
          {RECENT_ANOMALIES.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => onItemClick(item.segmentId)}
                className="flex w-full items-center justify-between rounded px-1 py-1 text-left text-xs hover:bg-gray-50 dark:hover:bg-white/5"
              >
                <span className="text-navy-700 dark:text-white">
                  {item.kmRange} · {item.description}
                </span>
                <span className="ml-2 shrink-0 text-gray-400">
                  {relativeTime(item.timestamp)}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
